import { User } from "firebase/auth"
import { IEventCollectionItem, IParticipatedEventItem, IUser } from "../interfaces"

class FirebaseUserMapper {
	public mapGoogleUserToUser(user: User): IUser {
		return {
			photoURL: user.photoURL,
			userId: user.uid,
			email: user.email,
			displayName: user.displayName,
			events: [],
		} as IUser
	}

	public mapEventToUserParticipatedEvent(event: IEventCollectionItem): IParticipatedEventItem {
		return {
			id: event._id,
			name: event.name,
			date: event.start,
			ticketImage: event.ticketImage,
		}
	}
}
export default new FirebaseUserMapper()
